import { Fetch } from '../helpers/fetchWrapper';

const DEFAULT_SKILLS_API_URL = 'https://sse-feedalabs.webevis.com/skills';

const skillsService = {
  _url: process.env.REACT_APP_SKILLS_API_URL || DEFAULT_SKILLS_API_URL,

  async getAllSkills() {
    return await Fetch.get(`${this._url}/list`);
  },

  async getSkillDetails(id) {
    return await Fetch.get(`${this._url}/detail?skill_id=${id}`);
  },
};

export default skillsService;
